import axios from "axios";
import { showSuccessNotification, showErrorNotification } from "actions/action-complete-notificator";

export const ACTION_ADD_CLIENT_PENDING = 'ACTION_ADD_CLIENT_PENDING';
export const ACTION_ADD_CLIENT_SUCCESS = 'ACTION_ADD_CLIENT_SUCCESS';
export const ACTION_ADD_CLIENT_ERROR = 'ACTION_ADD_CLIENT_ERROR';

function addClientPending() {
    return {
        type: ACTION_ADD_CLIENT_PENDING
    }
}

function addClientSuccess(clientId) {
    showSuccessNotification("Dodano klienta");
    return {
        type: ACTION_ADD_CLIENT_SUCCESS,
        clientId: clientId
    }
}

function addClientError(error) {
    showErrorNotification(error.response);
    return {
        type: ACTION_ADD_CLIENT_ERROR,
        error: error
    }
}

function addClientAction(data) {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/Client/';
    return dispatch => {
        dispatch(addClientPending());
        axios.post(url, data, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(addClientSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(addClientError(error));
            })
    }
}

export default addClientAction;
